import i18next from "i18next"

import dateService from "services/date"

import { REQUEST_REJECTED, REQUEST_ACCEPTED, REQUEST_FORCED } from "utils/constants"

export const getSteps = (bike) => {
    const bikeTransferRequest = bike?.propertyTransferRequest
    const bikeTransferRequestDate = bikeTransferRequest?.request_date
    const bikeTransferRequestResponseDate = bikeTransferRequest?.response_date

    const isBikeTransferRequestAccepted = bikeTransferRequest?.status === REQUEST_ACCEPTED
    const isBikeTransferRequestRejected = bikeTransferRequest?.status === REQUEST_REJECTED
    const isBikeTransferRequestForced = bikeTransferRequest?.status === REQUEST_FORCED

    // Add 1 day to the requested date (24h)
    // We use date-fns to add 1 day. Prevent time zone change
    const bikeTransferRequestExpiredDate = dateService.addDays(dateService.getDate(bikeTransferRequestDate), 1)

    const formattedTransferRequestResponseDate = bikeTransferRequestResponseDate && dateService.formatDate(bikeTransferRequestResponseDate, dateService.getCurrentDateFormat())
    const formattedTransferRequestExpiredDate = bikeTransferRequestDate && dateService.formatDate(bikeTransferRequestExpiredDate, dateService.getCurrentDateFormat(), false)

    return [
        {
            id: "SEND",
            label: i18next.t("back_and_buy.send_status", { ns: "bike" }),
            date: bikeTransferRequestDate && dateService.formatDate(bikeTransferRequestDate, dateService.getCurrentDateFormat())
        },
        {
            id: "WAITING",
            label: i18next.t("back_and_buy.waiting_status", { ns: "bike" }),
        },
        {
            id: "ACCEPTED",
            label: i18next.t("back_and_buy.confirmed_status", { ns: "bike" }),
            isDisabled: !isBikeTransferRequestAccepted,
            date: Boolean(isBikeTransferRequestAccepted) && formattedTransferRequestResponseDate
        },
        {
            id: "FORCED",
            label: i18next.t("back_and_buy.validated_status", { ns: "bike" }),
            date: Boolean(isBikeTransferRequestForced) && formattedTransferRequestResponseDate
        },
        {
            id: "EXPIRED",
            label: i18next.t("back_and_buy.expired_status", { ns: "bike" }),
            date: bikeTransferRequestDate && formattedTransferRequestExpiredDate,
            isActive: true
        },
        {
            id: "REJECTED",
            label: i18next.t("back_and_buy.rejected_status", { ns: "bike" }),
            date: Boolean(isBikeTransferRequestRejected) && formattedTransferRequestResponseDate,
            isActive: Boolean(bikeTransferRequestResponseDate)
        },
    ]
}